import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { MysqlRanks } from '../../../graphqlTypes'

const Container = styled.li`
  margin: 32px 0 0;
  padding: 0 3px;
  width: calc(100% / 3);
  &:first-child {
    margin: 0 auto;
    padding: 0 6px;
    width: 100%;
  }
`

const ImageFrame = styled(Link)<{ first: number | null }>`
  display: block;
  object-fit: contain;
  margin: 0 auto;
  text-decoration: none;
  width: ${({ first }) => (first ? '100%' : '100%')};
  height: ${({ first }) => (first ? 'auto' : '115px')};
`

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`

const TextInfo = styled.div`
  color: ${({ theme }) => theme.palette.font.main};
  font-weight: bold;
  margin: 10px 0 0;
  &:first-child {
    margin: 13px 0 0;
  }
`

const Manufacturer = styled.p<{ first: number | null }>`
  color: ${({ theme }) => theme.palette.font.sub};
  font-size: ${({ first }) => (first ? '12px' : '10px')};
  margin: 0 0 4px;
`

const ProductName = styled.p<{ first: number | null }>`
  font-size: ${({ first }) => (first ? '14px' : '10px')};
`

type Props = {
  rank: MysqlRanks
}

export default function ListItem({ rank }: Props) {
  const product = rank.products!
  const first = rank.rank === 1 ? 1 : null

  return (
    <Container>
      <ImageFrame first={first} to={product.fields!.pagePath!}>
        <LazyLoadComponent>
          <Image alt={product.name!} src={`${product.fields!.withEmblemImageUrl}?auto=format`} />
        </LazyLoadComponent>
      </ImageFrame>
      <TextInfo>
        {product.manufacturer && <Manufacturer first={first}>{product.manufacturer}</Manufacturer>}
        <ProductName first={first}>{product.name}</ProductName>
      </TextInfo>
    </Container>
  )
}
